import React from 'react'
import { Job } from '../app-types'
import { useHistory } from 'react-router-dom';
import { useState } from 'react'
import {Checkbox,Typography,Card,CardContent,Grid} from '@material-ui/core';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import LocalActivityOutlinedIcon from '@material-ui/icons/LocalActivityOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth0 } from "@auth0/auth0-react";

interface Props {
  job: Job;
  getJob: (jobId: number) => void;
  saveJob: (job: Job) => void;
  removeJob: (job: Job) => void;
}
/**
 * Hover over card animation
 */
const useStyles = makeStyles({
  root: {
    transition: "transform 0.3s ease-in-out"
  },
  cardHovered: {
    transform: "scale(1.02)"
  }
});

export const JobCard = ({ job, getJob, saveJob, removeJob }: Props) => {
  const [saved, setsaved] = useState<boolean>(job.saved)
  const [raised, setraised] = useState({ raised: false, shadow: 5 })

  const { user } = useAuth0();
  const { loginWithRedirect } = useAuth0();

  let history = useHistory();
  const classes = useStyles();

  const handleOnJobClick = (jobId: number):void => {
    getJob(jobId)
    history.push("/job-details") // eslint-disable-line no-restricted-globals
  }
  const handleAddRemove = ():void => {
    if(user) {
      setsaved((saved) => !saved);
      job.saved ? removeJob(job) : saveJob(job);
    } else loginWithRedirect()
  }

  return (
    <Card
      className={classes.root}
      classes={{ root: raised.raised ? classes.cardHovered : "" }}
      onMouseOver={() => setraised({ raised: true, shadow: 8 })}
      onMouseOut={() => setraised({ raised: false, shadow: 5 })}
      raised={raised.raised}
      elevation={raised.shadow}
    >
      <CardContent>
        <Grid container direction="column">
          <Grid container direction="row" spacing={1}>
            <Grid item xs={10} onClick={() => handleOnJobClick(job.jobId)}>
              <Typography variant="h6">
                <div>{job.jobTitle}</div>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Checkbox
                icon={<LocalActivityOutlinedIcon />}
                checkedIcon={<LocalActivityIcon />}
                checked={saved}
                onChange={handleAddRemove}
                inputProps={{
                  'aria-label': 'secondary checkbox'
                }}
              />
            </Grid>
          </Grid>
          <Grid container direction="row">
            <Grid item xs={6}>
              <Typography variant="overline">
                <div>{job.locationName}</div>
              </Typography>

            </Grid>
            <Grid item xs={6}>
              <Typography variant="overline">
                <div>{'£' + Job.calculateSalaryFreq(job.minimumSalary, job.maximumSalary)}</div>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  )
}
